/**
 * @generated SignedSource<<4b3132a54e3b8acef06c7bdd1fddf003>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly pageType: string | null;
  readonly vanityUriRef: string | null;
  readonly " $fragmentType": "SbSharedRefetchContainer_itemSearch";
};
export type SbSharedRefetchContainer_itemSearch$key = {
  readonly " $data"?: SbSharedRefetchContainer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefetchContainer_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vanityUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "56f0d134e98dd2feb516b4d2c51167d4";

export default node;
